import AxiosJob from "@/services/api/job/axios_job";

export default {

  getAllJobPoolStatuses: (params) => {
    return AxiosJob.get("job-pool-status", { params });
  },

  createJobPoolStatus: (data) => {
    return AxiosJob.post("job-pool-status", data);
  },

  updateJobPoolStatus: (id, data) => {
    return AxiosJob.put(`job-pool-status/${id}`, data);
  },

  deleteJobPoolStatus: (id) => {
    return AxiosJob.delete(`job-pool-status/${id}`);
  },

  getJobPoolStatusByJobDefinition: (jobDefinitionId) => {
    return AxiosJob.get(`job-pool-status/by/job-definition/${jobDefinitionId}`)
  },
}
